<template>
  <div class="skeleton_wrapper" :class="[skeleton + '_skeleton_wrapper']">
    <div
      v-if="nodata || error"
      class="nodata"
      :class="{ 'nodata-error': error, 'nodata-loading': loading }"
    >
      <div class="nodata_text">
        {{ error ? error.message : nodataText }}
      </div>
    </div>
    <HomeEventsSkeleton v-if="skeleton === 'homeEvents'" :loading="loading" />
    <HomeVideoSkeleton v-if="skeleton === 'homeVideo'" :loading="loading" />
    <VideoStreamSkeleton v-if="skeleton === 'videoStream'" :loading="loading" />
    <ClipVideoSkeleton v-if="skeleton === 'clipVideo'" :loading="loading" />
  </div>
</template>

<script>
import HomeEventsSkeleton from '@/components/skeletons/HomeEventsSkeleton.vue';
import HomeVideoSkeleton from '@/components/skeletons/HomeVideoSkeleton.vue';
import VideoStreamSkeleton from '@/components/skeletons/VideoStreamSkeleton.vue';
import ClipVideoSkeleton from '@/components/skeletons/ClipVideoSkeleton.vue';

export default {
  name: 'Skeleton',
  components: {
    HomeEventsSkeleton,
    HomeVideoSkeleton,
    VideoStreamSkeleton,
    ClipVideoSkeleton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    nodata: {
      type: Boolean,
      default: false,
    },
    nodataText: {
      type: String,
      default: '',
    },
    error: {
      type: Object,
      default: () => {},
    },
    skeleton: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss"></style>
